import { JPEG, JPG, PNG } from 'constants/mimeTypes'

export const acceptImageTypes = [JPEG, JPG, PNG].join(',')
